export default [
    {
        pic: "0",
        from: 2,
        to: 7,
        data: [
            {
                lang: "ar",
                text: "هل ترانا نلتقي أم أنها"
            },
            {
                lang: "dv",
                text: "އަހަރެމެން ބައްދަލުވާނޭ ކަމަށް ތިބާ ދެކެމުހެއްޔެވެ؟ "
            }
        ]
    },
    {
        from: 7,
        to: 13,
        data: [
            {
                lang: "ar",
                text: "كانت اللقيا على أرض السراب"
            },
            {
                lang: "dv",
                text: "އެހެންނޫނީ އަވާމެންދުރުގެ ބިމުގައި އެބައްދަލުވުން ނިމިއްޖެހެއްޔެވެ؟"
            }
        ]
    },
    {
        from: 13,
        to: 18,
        data: [
            {
                lang: "ar",
                text: "ثم ولت وتلاشى ظلها"
            },
            {
                lang: "dv",
                text: "ދެން އެ ދެމިގަނެ އޭގެ ހިޔަނި ފަނޑުވެގޮސްފިއެވެ"
            }
        ]
    },
    {
        from: 18,
        to: 23,
        data: [
            {
                lang: "ar",
                text: "واستحالت ذكريات للعذاب"
            },
            {
                lang: "dv",
                text: "އަދި އެއީ ވޭނީ ހަނދުމަތަކަކަށް ވެއްޖެއެވެ"
            }
        ]
    },
    {
        pic: 1,
        from: 23,
        to: 30,
        data: [
            {
                lang: "ar",
                text: "هكذا أسأل قلبي كلما"
            },
            {
                lang: "dv",
                text: "މިފަދައިން އަހަރެންގެ ހިތް ކޮންމެ ފަހަރަކު ސުވާލުކުރެއެވެ"
            }
        ]
    },
    {
        from: 30,
        to: 36,
        data: [
            {
                lang: "ar",
                text: "طالت الأيام من بعد الغياب"
            },
            {
                lang: "dv",
                text: "(އެއީ) ތިބާ ގެެއްލުމާއިއެކު ދުވަސްތައް ދިގުލާ ހިނދަކުއެވެ"
            }
        ]
    },
    {
        from: 36,
        to: 42,
        data: [
            {
                lang: "ar",
                text: "هكذا أسأل قلبي كلما"
            },
            {
                lang: "dv",
                text: "މިފަދައިން އަހަރެންގެ ހިތް ކޮންމެ ފަހަރަކު ސުވާލުކުރެއެވެ"
            }
        ]
        
    },
    {
        from: 42,
        to: 48,
        data: [
            {
                lang: "ar",
                text: "طالت الأيام من بعد الغياب"
            },
            {
                lang: "dv",
                text: "(އެއީ) ތިބާ ގެެއްލުމާއިއެކު ދުވަސްތައް ދިގުލާ ހިނދަކުއެވެ"
            }
        ]
    },
    {
        from: 48,
        to: 54,
        data: [
            {
                lang: "ar",
                text: "فإذا طيفك يرنـو باسما"
            },
            {
                lang: "dv",
                text: "އެއީ ތިބާގެ ފަނޑު ހިޔަނި ހިނިތުންވުމާއި އެކު ބަލާހިނދެވެ"
            }
        ]
    },
    {
        pic: 2,
        from: 54,
        to: 60,
        data: [
            {
                lang: "ar",
                text: "وكأني في استماع للجـواب "
            },
            {
                lang: "dv",
                text: "އޭގައި އަހަންނަށް، ތިބާ ޖަވާބުދޭ އަޑު އިވޭފަދައެވެ"
            }
        ]
    },
    {
        from: 60,
        to: 66,
        data: [
            {
                lang: "ar",
                text: "أولم نمضي على الحق معاً"
            },
            {
                lang: "dv",
                text: "ބަލަ އަހަރެމެން ޙައްޤުގެ މަގުގައި އެކީގައި ނުހިނގަމުހެއްޔެވެ؟"
            }
        ]
    },
    {
        from: 66,
        to: 71,
        data: [
            {
                lang: "ar",
                text: "كي يعود الخير للأرض اليباب"
            },
            {
                lang: "dv",
                text: "ހަނަފަސް ބިމަށް ދިރުން އަނބުރައި ގެނެވުމަށެވެ"
            }
        ]
    },
    {
        from: 71,
        to: 77,
        data: [
            {
                lang: "ar",
                text: "فمضينا في طريق شائك"
            },
            {
                lang: "dv",
                text: "އެހެންކަމުން ކަށިބޯ މަގެއްގައި އަހަރެމެން ހިނގީމުއެވެ"
            }
        ]
    },
    {
        pic: 3,
        from: 77,
        to: 83,
        data: [
            {
                lang: "ar",
                text: "ما تخلى فيه عن كل الرغاب"
            },
            {
                lang: "dv",
                text: "އެއަށްޓަކައި އަހަރެމެންގެ އެންމެހާ އުއްމީދެއް ދޫކޮށްލީމެވެ"
            }
        ]
    },
    {
        from: 83,
        to: 90,
        data: [
            {
                lang: "ar",
                text: "ودفنا الشوق في أعماقنا"
            },
            {
                lang: "dv",
                text: "އަދި އަހަރެމެންގެ ޝައުޤުތައް ނަފުސުގެ ތެރޭ ވަޅުލީމުއެވެ"
            }
        ]
    },
    {
        from: 90,
        to: 95,
        data: [
            {
                lang: "ar",
                text: "ومضينا في رضاء واحتساب"
            },
            {
                lang: "dv",
                text: "އަދި ރުހިގެންވާ ޙާލު އެއިލާހުގެ އަޖުރަށް އުއްމީދުކޮށް ހިނގީމުއެވެ"
            }
        ]
    },
    {
        from: 94,
        to: 101,
        data: [
            {
                lang: "ar",
                text: "قد تعودنا على السير معاً"
            },
            {
                lang: "dv",
                text: "އަހަރެމެން ވަނީ އެކީގައި ހިނގުމަށް އަހުދެއް ހަދާފައެވެ"
            }
        ]
    },
    {
        pic: 4,
        from: 101,
        to: 106,
        data: [
            {
                lang: "ar",
                text: "ثم أعجلت مجيباً للذهاب"
            },
            {
                lang: "dv",
                text: "ދެން ތިބާ އަވަސްވެގަނެ ވަކިވެގަތުމަށް އިޖާބަދިނެވެ"
            }
        ]
    },
    {
        from: 106,
        to: 112,
        data: [
            {
                lang: "ar",
                text: "حين نادى لي رب منعم"
            },
            {
                lang: "dv",
                text: "ނިއުމަތުގެ ރައްބެއް އަހަރެންނަށް ގޮވާލެއްވިހިނދެވެ"
            }
        ]
    },
    {
        from: 112,
        to: 118,
        data: [
            {
                lang: "ar",
                text: "لي حياتي في جنان ورحاب"
            },
            {
                lang: "dv",
                text: "ޖަންނަތް ތަކުގެ މެދުގައި އަހަންނަށް ހަޔާތެއް އަދި ތަނަވަސް ބިމަކަށެވެ"
            }
        ]
    },
    {
        from: 118,
        to: 124,
        data: [
            {
                lang: "ar",
                text: "ولقاء في نعيم دائم"
            },
            {
                lang: "dv",
                text: "ދާއިމީ ނިޢުމަތުގައިވާ ބައްދަލުވުމަކަށެވެ"
            }
        ]
    },
    {
        from: 124,
        to: 131,
        data: [
            {
                lang: "ar",
                text: "لجنود الله مرحا للصحاب"
            },
            {
                lang: "dv",
                text: "ﷲގެ ސިފައިންނަށް އުފާވެރި އެއްވުމެކެވެ"
            }
        ]
    },
    {
        pic: 5,
        from: 131,
        to: 136,
        data: [
            {
                lang: "ar",
                text: "قدموا الأرواح والعمر فدا"
            },
            {
                lang: "dv",
                text: "އެވެރިންގެ ރޫޙުތަކާއި ޢުމުރު ފިދާކުރިއެވެ"
            }
        ]
    },
    {
        from: 136,
        to: 142,
        data: [
            {
                lang: "ar",
                text: "مستجيبين على غير ارتياب"
            },
            {
                lang: "dv",
                text: "ގުޑުމެއްނުވާ އަޒުމުގައި އިޖާބަދެމުންނެވެ"
            }
        ]
    },
    {
        from: 142,
        to: 149,
        data: [
            {
                lang: "ar",
                text: "فليهب قلبك من غفلاته"
            },
            {
                lang: "dv",
                text: "އެއީ ތިބާގެ ހިތް އޭގެ ޣާފިލުކަމުން ހޭޖައްސަމުންނެވެ"
            }
        ]
    },
    {
        from: 149,
        to: 154,
        data: [
            {
                lang: "ar",
                text: "فلقاء الخلد في تلك الرحاب"
            },
            {
                lang: "dv",
                text: "އެހެންކަމުން، ދާއިމީ ބައްދަލުވުން އެފަދަ ތަނަވަސް ބިމެއްގައެވެ"
            }
        ]
    },
    {
        from: 154,
        to: 160,
        data: [
            {
                lang: "ar",
                text: "أيها الراحل عمراً في شكاتي"
            },
            {
                lang: "dv",
                text: "އޭ ދަތުރުވެރިޔާއެވެ! އަހަރެންގެ ޝަކުވާތަކަށް މާފުކުރާށެވެ"
            }
        ]
    },
    {
        pic: 6,
        from: 160,
        to: 166,
        data: [
            {
                lang: "ar",
                text: "فإلى طيفك أنات عتاب"
            },
            {
                lang: "dv",
                text: "އެހެނީ އަހަންނަށްވީ ތިބާގެ ފަނޑު ހިޔަންޏެކެވެ, އެއަށް ޝަކުވާއެކެވެ"
            }
        ]
    },
    {
        from: 166,
        to: 172,
        data: [
            {
                lang: "ar",
                text: "قد تركت القلب يدمي مثقلاً"
            },
            {
                lang: "dv",
                text: "އަހަރެންގެ ހިތް ލެއިން ފޯވުމަށް އަހަރެން ދޫކޮށްލައިފީމެވެ"
            }
        ]
    },
    {
        from: 172,
        to: 178,
        data: [
            {
                lang: "ar",
                text: "تائهاً في الليل في عمق الضباب"
            },
            {
                lang: "dv",
                text: "ދުންފިނި ރޭގަނޑުގެތެރެއަށް ގެއްލިދިޔުމަށެވެ"
            }
        ]
    },
    {
        from: 178,
        to: 184,
        data: [
            {
                lang: "ar",
                text: "وإذا أطوي وحيداً حائراً"
            },
            {
                lang: "dv",
                text: "އަދި އެކަނިމާއެކަނި ގަބުކައިފައި އަހަރެން ދަތުރުކުރާނަމަ"
            }
        ]
    },
    {
        from: 184,
        to: 190,
        data: [
            {
                lang: "ar",
                text: "أقطع الدرب طويلاً في اكتئاب"
            },
            {
                lang: "dv",
                text: "އަހަރެންގެ ދަތުރު ހުއްޓަމެވެ. މީގެ ނުތަނަވަސްކަމުގެ ދިގުކަމުންނެވެ."
            }
        ]
    },
    {
        from: 190,
        to: 197,
        data: [
            {
                lang: "ar",
                text: "وإذا الليل خضم موحش"
            },
            {
                lang: "dv",
                text: "އަދި ރޭގަނޑަކީ ދަމާލެވިފައިވާ ކަނޑެއްނަމަ"
            }
        ]
    },
    {
        pic: 7,
        from: 197,
        to: 203,
        data: [
            {
                lang: "ar",
                text: "تتلاقى فيه أمواج العذاب"
            },
            {
                lang: "dv",
                text: "ވޭނުގެ ރާޅުތައް އަހަރެންނާ ލައިގަންނަމުން ދެއެވެ"
            }
        ]
    },
    {
        from: 203,
        to: 209,
        data: [
            {
                lang: "ar",
                text: "لم يعد يبرق في ليلي سنا"
            },
            {
                lang: "dv",
                text: "އަހަރެންގެ ރޭތަކުގެ އަލިކަން އިޔާދަނުވެއެވެ"
            }
        ]
    },
    {
        from: 209,
        to: 214,
        data: [
            {
                lang: "ar",
                text: "قد توارت كل أنوار الشهاب"
            },
            {
                lang: "dv",
                text: "އަދި ފިޔަޖަހަމުންދާ ތަރިތަކުގެ އަލިކަން ގެއްލިއްޖެއެވެ"
            }
        ]
    },
    {
        from: 214,
        to: 220,
        data: [
            {
                lang: "ar",
                text: "غير أني سوف أمضي مثلما"
            },
            {
                lang: "dv",
                text: "އެހެންވިޔަސް އަހަރެން ކުރިޔަށް ދާހުށީމެވެ"
            }
        ]
    },
    {
        pic: 8,
        from: 220,
        to: 226,
        data: [
            {
                lang: "ar",
                text: "كنت تلقاني في وجه الصعاب"
            },
            {
                lang: "dv",
                text: "ތިބާވެސް އުދަގުލުގެ ކުރިމަތީ އަހަރެންނާ ބައްދަލުކުރި ފަދައިންނެވެ"
            }
        ]
    },
    {
        from: 226,
        to: 233,
        data: [
            {
                lang: "ar",
                text: "سوف يمضي الرأس مرفوعاًفلا"
            },
            {
                lang: "dv",
                text: "އަހަރެންގެ އިސް އުފުލައި ކުރިޔަށްދާ ހުށީމެވެ. އެހެންކަމުން"
            }
        ]
    },
    {
        pic: 9,
        from: 233,
        to: 239,
        data: [
            {
                lang: "ar",
                text: "يرتضي ضعفاً بقول أو جوابي"
            },
            {
                lang: "dv",
                text: "ބަހުގައިވެސް ޖަވާބުގައިވެސް ބަލިކަށްޓެއް ނުވާހުށީމެވެ"
            }
        ]
    },
    {
        from: 239,
        to: 245,
        data: [
            {
                lang: "ar",
                text: "سوف تحدوني دماء عابقات"
            },
            {
                lang: "dv",
                text: "ފޮނި ލޭގެ ވަހުން އަހަރެންނަށް މަގުދައްކާނެތެވެ"
            }
        ]
    },
    {
        from: 245,
        to: 251,
        data: [
            {
                lang: "ar",
                text: "قد أنارت كل فج للذهاب"
            },
            {
                lang: "dv",
                text: "އަދި ގެއްލެމުންދާ އުދަރެހުން އަލިކަން ފާޅުވެއްޖެއެވެ"
            }
        ]
    },
    {
        from: 250,
        to: 258,
        data: [
            {
                lang: "ar",
                text: "هل ترانا نلتقي أم أنها"
            },
            {
                lang: "dv",
                text: "އަހަރެމެން ބައްދަލުވާނޭ ކަމަށް ތިބާ ދެކެމުހެއްޔެވެ؟ "
            }
        ]
    },
    {
        pic:'last',
        from: 258,
        to: 263,
        data: [
            {
                lang: "ar",
                text: "كانت اللقيا على أرض السراب"
            },
            {
                lang: "dv",
                text: "އެހެންނޫނީ އަވާމެންދުރުގެ ބިމުގައި އެބައްދަލުވުން ނިމިއްޖެހެއްޔެވެ؟"
            }
        ]
    },
    {
        from: 263,
        to: 269,
        data: [
            {
                lang: "ar",
                text: "ثم ولت وتلاشى ظلها"
            },
            {
                lang: "dv",
                text: "ދެން އެ ދެމިގަނެ އޭގެ ހިޔަނި ފަނޑުވެގޮސްފިއެވެ"
            }
        ]
    },
    {
        from: 269,
        to: 275,
        data: [
            {
                lang: "ar",
                text: "واستحالت ذكريات للعذاب"
            },
            {
                lang: "dv",
                text: "އަދި އެއީ ވޭނީ ހަނދުމަތަކަކަށް ވެއްޖެއެވެ"
            }
        ]
    },
]